import apiClient from "../ApiClient";
import AuthClient from "../../api/AuthClient";
import {
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  REFRESH_TOKEN,
  REGISTER_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  SEND_OTP_FAILURE,
  SEND_OTP_REQUEST,
  SEND_OTP_SUCCESS,
} from "./authActionTypes";

// set the actions

// 1. login
export const loginRequest = () => {
  return {
    type: LOGIN_REQUEST,
  };
};

// 2. set and store the user info in case of success
export const loginSuccess = (userInfo) => {
  return {
    type: LOGIN_SUCCESS,
    payload: userInfo,
  };
};

// set the error message in case of an error
export const loginFailure = (error) => {
  return {
    type: LOGIN_FAILURE,
    payload: error,
  };
};

// Registration of the user
export const signupRequest = () => {
  return {
    type: REGISTER_REQUEST,
  };
};

// incase the registration was successful
export const signupSuccess = (user) => {
  return {
    type: REGISTER_SUCCESS,
    payload: user,
  };
};

// incase the registration was unsuccessful
export const signupFailure = (error) => {
  return {
    type: REGISTER_FAILURE,
    payload: error,
  };
};

export const logoutRequest = () => {
  return {
    type: LOGOUT_REQUEST,
  };
};
// set and store the success message in case of logout success
export const logoutSuccess = (msg) => {
  return {
    type: LOGOUT_SUCCESS,
    payload: msg,
  };
};

// set and store the error message in case of logout failure
export const logoutFailure = (error) => {
  return {
    type: LOGOUT_FAILURE,
    payload: error,
  };
};

// send  OTP
export const otpRequest = () => {
  return {
    type: SEND_OTP_REQUEST,
  };
};
// set and store the success message in case of logout success
export const otpRequestSuccess = (msg) => {
  return {
    type: SEND_OTP_SUCCESS,
    payload: msg,
  };
};

// set and store the error message in case of logout failure
export const otpRequestFailure = (error) => {
  return {
    type: SEND_OTP_FAILURE,
    payload: error,
  };
};

// refresh token
export const refreshToken = () => {
  return {
    type: REFRESH_TOKEN,
  };
};

// ----------------------- send to reducer -----------------

// login using axios

export function login(user) {
  return function action(dispatch) {
    dispatch(loginRequest);

    return AuthClient.login(user)
      .then((response) => {
        console.log(response);
        dispatch(loginSuccess(response));
        return true;
      })
      .catch((error) => {
        console.log(error);
        dispatch(logoutSuccess("Failed to log you in. Retry."));
        return false;
      });
  };
}

// logout function
export function logoutRequestAction() {
  return function action(dispatch) {
    dispatch(logoutRequest());
    return AuthClient.logout()
      .then((response) => {
        dispatch(logoutSuccess("Logged out successfully"));
        // initializeToken();
        return true;
      })
      .catch((error) => {
        dispatch(loginFailure("Failed to log you out"));
        return false;
      });
  };
}

export function sendOtpAction() {
  return function action(dispatch) {
    dispatch(otpRequest());

    return apiClient
      .post("/api/sendOtp")
      .then((response) => {
        dispatch(otpRequestSuccess(response.data.message));
        return true;
      })
      .catch((error) => {
        dispatch(otpRequestFailure("Something went wrong! Retry."));
        return false;
      });
  };
}
